/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client } from "../client";
import type { ProxyResource } from "../resources";
import { BasicRepository } from "./basicRepository";
export class ProxyRepository extends BasicRepository<ProxyResource, any> {
    constructor(client: Client) {
        super("Proxies", client);
    }
}
